import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/src/stylus/app.styl';
import colors from './colors';

Vue.use(Vuetify, {
  theme: {
    primary: colors.kiwiGreen,
  },
  iconfont: 'md',
});
